import React from "react";

export default function Developers() {
  return <div>Developers</div>;
}
